import React, { useEffect, useState } from "react";

import {  Route, Routes } from "react-router-dom";

import Index from "./pages/Index";
import GameChoiceReaction from "./pages/GameChoiceReaction";
import GameStroop from "./pages/GameStroop";
import GameDigitalSpanBackward from "./pages/GameDigitalSpan";
import GameMentalRotation from "./pages/GameMentalRotation";
import GameWisconsinCardSorting from "./pages/GameWisconsinCardSorting";
import Result from "./pages/Result";
import styles from "./app.module.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import IntroGame from "./pages/IntroGame";
import Prepare from "./pages/Prepare";
import Congratulation from "./pages/Congratulation";
import FinalResult from "./pages/FinalResult";
import { useData } from "./contexts/DataContext";
import Suggestions from "./pages/Suggestions";
import ShareRedirect from "./pages/ShareRedirect";
import ErrorPage from "./pages/ErrorPage";

const navOrder = [
  // ErrorPage,
  IntroGame,
  Index,
  Prepare,
  GameChoiceReaction,
  GameStroop,
  // GameDigitalSpanForward,
  GameDigitalSpanBackward,
  GameMentalRotation,
  GameWisconsinCardSorting,
  Congratulation,
  Result,
  FinalResult,
  Suggestions,
];

const App = () => {
  const [result, setResult] = useState({});
  const [shareId, setShareId] = useState();
  const [finishGame,setFinishGame] = useState();
  const [navIndex, setNavIndex] = useState(0);
  const DisplayPage = navOrder[navIndex];
  const { clearDataGame,allresult } = useData();
  useEffect(() => {
    const onHashChange = () => {
      const hashStr =
        window.location.hash.length > 1
          ? window.location.hash.substring(1)
          : "";
      if (!hashStr) return;
      const params = new URLSearchParams(hashStr);
      if (params.get("game").length > 0) {
        const num = parseInt(params.get("game") ?? "0");
        if (navOrder[num]) {
          setNavIndex(num);
        }
      }
    };

    onHashChange();
    window.addEventListener("hashchange", onHashChange, false);

    return () => {
      window.removeEventListener("hashchange", onHashChange, false);
    };

  }, []);


  return (
    <Routes>
        
          <Route path="result/:id" element={<ShareRedirect setNavIndex={setNavIndex} shareId={shareId}
                    setShareId={setShareId} />}>
          </Route>
          <Route path="*" element={<>
            <div className={styles.main}>
              <div className={styles.bodytop}>
                <div className={styles.body}>
                  <Navbar index={navIndex} />
                  <DisplayPage
                    navigateNextPage={() => setNavIndex(navIndex + 1)}
                    navigatePrevPage={() => setNavIndex(navIndex - 1)}
                    restartGame={() => {
                      clearDataGame();
                      setResult([]);
                      setNavIndex(0);
                    }}
                    forceEndGame={() => setNavIndex(8)}
                    shareId={shareId}
                    setShareId={setShareId}
                    finishGame={finishGame}
                    setFinishGame={setFinishGame}
                    submitResult={(gameResult) =>
                      {
                        setResult((oldResult) => {
                          return {...oldResult, gameResult}
                        })
                      }
                    }
                    result={result}
                  />
                </div>
              </div>
              {/* {navIndex === 9 &&(
                <Share/>
              )}             */}
              <Footer />
            </div>
            </>}>
            
          </Route>
        
      </Routes>
  );
};

export default App;
